const palette = JSON.parse(document.querySelector('#color-palette-json').innerText);

class CustomPaletteProduct extends HTMLElement {
  color;

  connectedCallback() {
    this.color = palette.find(p => p.label.toLowerCase() === this.dataset.color.toLowerCase()).color;
  }

  getColor = () => {
    return this.color;
  }

  getColorLabel = () => {
    return this.dataset.color;
  }

  activate = () => {
    this.classList.add('active');
  }

  deactivate = () => {
    this.classList.remove('active');
  }
}
if (!customElements.get('custom-palette-product')) {
  customElements.define('custom-palette-product', CustomPaletteProduct);
}

class CustomPaletteRing extends HTMLElement {
  chart; canvas; data; backgrounds; colors; products;

  connectedCallback() {
    this.canvas = this.querySelector('canvas');
    this.products = this.querySelectorAll('custom-palette-product');
    this.getColors();
  }

  destroyChart = () => {
    if(this.chart != undefined)
      this.chart.destroy();
  }

  getColors = () => {
    this.colors = Array.from(this.products).map(product => product.getColorLabel());
    this.data = [];
    this.backgrounds = Array.from(this.products).map(product => product.getColor());
    this.colors.forEach(color => {
      this.data.push(100/this.colors.length);
    });
  }

  createChart = () => {
    if(this.chart != undefined){
      this.destroyChart();
    }
    
    this.chart = new Chart(this.canvas, {
      type: 'doughnut',
      data: {
        labels: this.colors,
        datasets: [{
          label: 'My First Dataset',
          data: this.data,
          backgroundColor: this.backgrounds,
          borderColor: this.backgrounds,
        }]
      },
      options: {
        onClick: (e) => {
          var elements = this.chart.getElementsAtEventForMode(e, 'index', { intersect: true }, false);
          this.setActive(elements[0]);
        },
        datasets: {
          doughnut: {
            borderColor: 'transparent',
            cutout: '80%'
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        }
      }
    });
  }

  setActive = (e) => {
    var index = e.index;
    const dataset = this.chart.data.datasets[0];
    
    dataset.borderColor = this.backgrounds.slice(); 
    dataset.borderColor[index] = 'black';
    
    this.chart.update();

    this.products.forEach(product => {
      product.deactivate();
    });
    this.products[index].activate();
  }

  findColor = (color) => {
    return palette.find(p => p.label.toLowerCase() === color.toLowerCase()).color;
  }

}
if (!customElements.get('custom-palette-ring')) {
  customElements.define('custom-palette-ring', CustomPaletteRing);
}


class CustomPalette extends HTMLElement {
  swiper; rings; ring;

  connectedCallback() {
    this.rings = this.querySelectorAll('custom-palette-ring');
    this.swiper = this.querySelector('theme-swiper');
    this.swiper.swiper.on('slideChangeTransitionEnd', (e) => {
      this.getRing();
    });
    this.getRing();
  }

  getRing = () => {
    this.ring = this.querySelector('.swiper-slide-active custom-palette-ring');
    if(this.ring != undefined){
      this.rings.forEach(ring => {
        ring.destroyChart();
      });
      this.ring.createChart();   
    }
  }

}
if (!customElements.get('custom-palette')) {
  customElements.define('custom-palette', CustomPalette);
}

/* read more less */

class ReadMore extends HTMLElement {
  expanded; expandible; link; text;
  static classes = {
    expanded: 'expanded',
    link: 'button button--outline'
  }

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.text = this.querySelector(':scope > div');
    this.expanded = false;
    this.expandible = this.text.scrollHeight > this.text.clientHeight;
    if(this.expandible){
      this.addLink();
    }
  }

  addLink = () => {
    this.link = document.createElement('a');
    this.link.setAttribute('href', '#');
    this.link.innerText = this.dataset.moreText;
    ReadMore.classes.link.split(' ').forEach(c => {
      this.link.classList.add(c);
    });
    this.link.addEventListener('click', (e) => {
      this.toggle(e);
    });
    this.appendChild(this.link);
  }

  toggle = (e) => {
    if(e != undefined)
      e.preventDefault();
    if(this.expanded)
      this.close();
    else
      this.open();
  }

  open = () => {
    this.classList.add(ReadMore.classes.expanded);
    this.link.innerText = this.dataset.lessText;
    this.expanded = true;
  }

  close = () => {
    this.classList.remove(ReadMore.classes.expanded);
    this.link.innerText = this.dataset.moreText;
    this.expanded = false;
  }
}
if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}